export function normalizeName(name: string | null | undefined): string {
    return (name ?? '').trim().replace(/\s+/g, ' ');
}
